import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Filter from 'rp-react-common/Filter';
import columns from './columns';
import FilteringComponent from '../../shared/filter';
import categoriesFactory from './categories';
import categoriesReducer from './reducer';

class Results extends FilteringComponent {
    constructor(props) {
        super(props);

        const {
            seasonInfo,
            seasonsAvailable,
            profile: { courseTypeCode },
            principleRaceResults,
        } = props.data;

        const { coursePrincipalSeason, raceType, raceStatusType } = seasonInfo;

        this.state = {
            data: principleRaceResults,
            categories: categoriesFactory(
                raceStatusType, courseTypeCode, raceType,
                coursePrincipalSeason, seasonsAvailable
            ),
            loading: false,
            fetchError: false,
        };

        const { name, id } = this.props.params;
        this.columns = columns(name, id);

        // key for getting info from API request
        this.dataKey = 'principleRaceResults';
    }

    renderDefaultStatus() {
        const {
            raceStatusType, raceType, coursePrincipalSeason: year,
        } = this.props.data.seasonInfo;

        const years = raceType === 'jumps' ? `${year}-${year + 1}` : year;
        const raceStatus = raceStatusType === 'big-race' ? 'Big races' : 'All races';

        return (
            <h2 className="ui-filter__statusText">
                {raceStatus}, {raceType}, {years}
            </h2>
        );
    }


    render() {
        const { data, categories, loading, fetchError } = this.state;

        return (
            <section className="cp-results">
                <Filter
                    categories={categories}
                    categoriesReducer={categoriesReducer}
                    columns={this.columns}
                    fetchError={fetchError}
                    onFilterApply={this.onFilterApply}
                />
                {!fetchError && (
                    <RpTable
                        columns={this.columns}
                        data={data}
                        loading={loading}
                        initialSortIdx={0}
                        noDataText="No results found"
                    />
                )}
            </section>
        );
    }
}

Results.propTypes = {
    data: PropTypes.shape({
        seasonInfo: PropTypes.shape({
            coursePrincipalSeason: PropTypes.number,
            raceStatusType: PropTypes.string,
            raceType: PropTypes.string,
        }),
        principleRaceResults: PropTypes.arrayOf(PropTypes.shape({
            horseStyleName: PropTypes.string,
            horseUid: PropTypes.number,
            prizeSterling: PropTypes.number,
            raceDatetime: PropTypes.string,
            raceInstanceTitle: PropTypes.string,
            raceInstanceUid: PropTypes.number,
            trainerStyleName: PropTypes.string,
            trainerUid: PropTypes.number,
        })),
    }).isRequired,
    params: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./src/js/course/results/Results.jsx